export const PASSWORD_FORGOT_ENDPOINT = {
    method: 'POST',
    path: '/api/v1/auth/password/forgot',
};
export const PASSWORD_RESET_ENDPOINT = {
    method: 'POST',
    path: '/api/v1/auth/password/reset',
};
//# sourceMappingURL=password.js.map